// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"094892bf","721":"d5222166","850":"3bc8086a"}[chunkId] + ".chunk.css";
};